import { memo } from 'react';

import type { MarketplaceBrowseMapMarkerFragment } from '../browse/__generated__/marketplace-browse.zeus';
import { MapMarker } from './MapMarker';
import type { MapMarkerProps } from './types';

interface MarketplaceMapMarkerProps extends Omit<MapMarkerProps, 'property' | 'onClick'> {
  property: MarketplaceBrowseMapMarkerFragment;
  handleFetchPropertyDetails: (addressId: string) => void;
  isLiked: boolean;
}

export const MarketplaceMapMarker = memo(
  ({
    property,
    handleFetchPropertyDetails,
    isLiked,
    isSelected,
    isLoading,
  }: MarketplaceMapMarkerProps) => {
    const { addressId, location, ...listing } = property;

    const handleOnClick = () => {
      handleFetchPropertyDetails(addressId);
    };

    const markerProperty = {
      ...listing,
      addressId,
      latitude: location.latitude,
      longitude: location.longitude,
      isLiked,
    };

    return (
      <MapMarker
        property={markerProperty}
        onClick={handleOnClick}
        isSelected={isSelected}
        isLoading={isLoading}
      />
    );
  },
);

MarketplaceMapMarker.displayName = 'MarketplaceMapMarker';
